import React, { useState, useEffect } from 'react';
import performApiRequest from '../utils/performApiRequest';
import { API_ENDPOINTS } from '../utils/endpoints';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import DownloadButton from './downloadButton';
import {Worker, Viewer} from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/styles.min.css';


interface FileModalProps {
    isOpen: boolean;
    onClose: () => void;
    uploadedFiles: {[key: string]: any};
    openFileUploadModalInParent: () => void;
}

const ExpenseReportRequestFilesModal: React.FC<FileModalProps> = ({ isOpen, onClose, uploadedFiles, openFileUploadModalInParent }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const file = uploadedFiles[activeIndex];
    const goToNextFile = () => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % uploadedFiles.length);
    };
    
    const goToPrevFile = () => {
        setActiveIndex((prevIndex) => (prevIndex - 1 + uploadedFiles.length) % uploadedFiles.length);
    };

    const deleteFile = async (file_id: number) => {
        if (uploadedFiles.length <= 1) {
            alert("Debe haber al menos un archivo por gasto.");
            return;
        }

        if (window.confirm("Presiona Aceptar para confirmar la eliminación del archivo.")) {
            const endpoint = API_ENDPOINTS.deleteFileFromExpenseReportRequest;
            
            const requestOptions = {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({file_id})
            }

            const response = await performApiRequest(endpoint, requestOptions);
            if (response.status === 204) {
                window.location.reload();
            }
        }
    }

    const [zoom] = useState(0.6);
    const [blobUrl, setBlobUrl] = useState<string | null>(null);
    const zoomPluginInstance = zoomPlugin();
    const { ZoomInButton, ZoomOutButton } = zoomPluginInstance;

    

    useEffect(() => {
        const fetchFile = async () => {
            const requestOptions = {
                method: 'GET',
                params: {
                    url: file.file_url,
                },
                responseType: 'blob', // Ensure the response is treated as a Blob
            };
            const endpoint = `${API_ENDPOINTS.viewParticularExpenseReportFile}`;
            const response = await performApiRequest(endpoint, requestOptions);
            console.log("Response:", response);
            if (response.status === 200) {
                // Convert response.data to a Blob if it's not already
                let blob;
                if (response.data instanceof Blob) {
                    blob = response.data;
                } else {
                    blob = new Blob([response.data],{ type: 'application/pdf' });
                }
                setBlobUrl(URL.createObjectURL(blob));
            } else {
                console.error('Error al cargar el archivo:', response.statusText);
            }
        };
        if (isPDF(file.file_name)) {
            // Only fetch the file if it is a PDF
            fetchFile();
        } else {
            // Reset blobUrl if the file is not a PDF
            setBlobUrl(null);
        }
    }, [file]);


    

    return (
        <div className={`modal ${isOpen ? 'open' : ''} w-full max-w-none`}>
            <div className="modal-content mt-4 w-full">
                <div className="flex flex-col md:flex-row md:justify-between justify-center">
                    <button onClick={onClose} className="w-1/4 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mb-2 mx-auto block">
                        Cerrar
                    </button>
                </div>
                <h2 className="text-gray-700 text-lg font-bold mb-4 text-center">Archivos subidos</h2>
                { uploadedFiles.length > 1 && (
                    <div className="text-center text-md"> Utiliza las flechas para desplazarte entre los archivos. </div>
                )}
                <div className="flex flex-col px-1 py-4 bg-white shadow rounded-lg w-full">
                    <div className="relative flex items-center w-full">
                        {uploadedFiles.length > 1 && (
                            <button onClick={goToPrevFile}>{<KeyboardArrowLeftIcon fontSize="large"/>}</button>
                        )}
                        {(uploadedFiles.length > 0) ? (
                        <div className="flex flex-col lg:flex-row mx-auto mb-4 w-full">
                            <div className="flex flex-col w-full lg:w-1/4 px-2 mb-4 lg:mb-0">
                                <div className="w-full flex flex-col items-center">
                                    <h2 className="text-gray-700 text-lg text-center font-bold mb-4">Archivo {file.id}</h2>
                                    <DownloadButton fileName={file.file_name}/>
                                </div>
                                <div className="mt-10 w-full flex flex-col justify-between">
                                    <button className="mr-2 mt-4 bg-red-600 hover:bg-red-800 text-white px-1 py-1 rounded-md" onClick={() => deleteFile(file.id)}>
                                        Eliminar archivo 
                                    </button>
                                    <button onClick={openFileUploadModalInParent} className="mr-2 mt-4 bg-blue-500 hover:bg-blue-700 text-white px-1 py-1 rounded-md">
                                        Agregar archivo
                                    </button>
                                </div>
                            </div>
                            <div className="flex flex-col w-full lg:w-3/4 px-2">
                                <div className="w-full h-full flex justify-center items-start mx-auto">
                                    <div className="w-full h-full">
                                        {isPDF(file.file_name) ? (
                                            <div className="border p-2 h-[70vh] w-full flex flex-col">
                                                <div className="botones-zoom mb-2 flex flex-row space-x-2 justify-center items-center">
                                                    <ZoomOutButton />
                                                    <ZoomInButton />
                                                </div>
                                                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                                                    {blobUrl && (
                                                        <Viewer fileUrl={blobUrl} defaultScale={zoom} plugins={[zoomPluginInstance]} />
                                                    )}
                                                </Worker>
                                            </div>
                                            /*<embed src={file.file_url} type="application/pdf" className="max-w-full h-full"/>*/
                                        ) : (
                                            <InnerImageZoom
                                                src={file.file_url}
                                                zoomSrc={file.file_url}
                                                zoomType="hover" // o "click"
                                                zoomPreload={true}
                                                className="w-full"
                                            />
                                            /*<img src={file.file_url} alt={`Archivo ${file.id}`} className="max-w-full h-auto"/>*/
                                        )}
                                    </div>
                                </div>
                            </div>            
                        </div>
                        ) : (
                            <div className="text-center font-bold"> No ha subido archivos. </div>
                        )}
                        {uploadedFiles.length > 1 && (
                            <button onClick={goToNextFile}>{<KeyboardArrowRightIcon fontSize="large"/>}</button>
                        )}
                    </div>
                    </div>
                </div>
        </div>
    );
};

const isPDF = (fileName: string) => {
    return /\.pdf$/i.test(fileName);
};

export default ExpenseReportRequestFilesModal;